import { useEffect, useState } from "react";
import styles from "./header.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
const Header = () => {
  const [isSideMenuVisible, setIsSideMenuVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const [activeLink, setActiveLink] = useState<String>("home");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const path = location.pathname;
    if (path === "/") setActiveLink("home");
    else if (path.startsWith("/services")) setActiveLink("services");
    else if (path === "/stylists") setActiveLink("stylists");
    else if (path === "/classes") setActiveLink("classes");
    else if (path === "/memberships") setActiveLink("memberships");
    else if (path === "/contact") setActiveLink("contact");
    else if (path === "/shop") setActiveLink("shop");
  }, [location.pathname]);

  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) &&
      document.documentElement.clientWidth > 768
    ) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  }
  return (
    <>
      <div className={`${styles["container"]}`}>
        {/* <div className={`${isScrolled ? styles["logo-container-scrolled"] : styles["logo-container"]}`}> */}
        <div
          className={`${
            isScrolled
              ? styles["logo-container-scrolled"]
              : styles["logo-container-scrolled"]
          }`}
        >
          <img
            draggable={false}
            src={
              document.documentElement.clientWidth > 768
                ? isScrolled
                  ? "https://ik.imagekit.io/euo36lugk/meraki/merakilogo1_1_iqs--eyeW.png?updatedAt=1685192727141"
                  : "https://ik.imagekit.io/euo36lugk/meraki/merakilogo1_1_iqs--eyeW.png?updatedAt=1685192727141"
                : "https://ik.imagekit.io/euo36lugk/meraki/merakilogo1_1_iqs--eyeW.png?updatedAt=1685192727141"
            }
            alt="meraki-logo"
            onClick={() => {
              setIsSideMenuVisible(false);
              navigate("/");
            }}
          />
          <div
            className={`${styles["hamburger-container"]} `}
            onClick={() => {
              setIsSideMenuVisible(!isSideMenuVisible);
            }}
          >
            <img
              draggable={false}
              src="/img/hamburger-button.svg"
              alt="hamburger"
            />
          </div>
        </div>

        <nav
          className={
            isSideMenuVisible
              ? isScrolled
                ? `${styles["show-side-menu"]} ${styles["show-side-menu-scrolled"]}`
                : styles["show-side-menu"]
              : ""
          }
        >
          <ul>
            <li
              className={activeLink === "home" ? styles["active-link"] : ""}
              onClick={() => {
                setIsSideMenuVisible(false);
                setActiveLink("home");
                navigate("/");
              }}
            >
              Home
            </li>
            <li
              className={activeLink === "services" ? styles["active-link"] : ""}
              onClick={() => {
                setIsSideMenuVisible(false);
                setActiveLink("services");
                navigate("/services");
              }}
            >
              Services
            </li>
            <li
              className={activeLink === "stylists" ? styles["active-link"] : ""}
              onClick={() => {
                setIsSideMenuVisible(false);
                setActiveLink("stylists");
                navigate("/stylists");
              }}
            >
              Stylists
            </li>
            <li
              className={activeLink === "classes" ? styles["active-link"] : ""}
              onClick={() => {
                setIsSideMenuVisible(false);
                navigate("/classes");
              }}
            >
              Classes
            </li>
            <li
              className={activeLink === "memberships" ? styles["active-link"] : ""}
              onClick={() => {
                setIsSideMenuVisible(false);
                setActiveLink("memberships");
                navigate("/memberships");
              }}
            >
              Memberships
            </li>
            <li
              className={activeLink === "contact" ? styles["active-link"] : ""}
              onClick={() => {
                setIsSideMenuVisible(false);
                setActiveLink("contact");
                navigate("/contact");
              }}
            >
              Contact
            </li>
          </ul>
          <label
            className={`${styles["shop-link"]}`}
            onClick={() => {
              setIsSideMenuVisible(false);
              navigate("/shop");
            }}
          >
            Shop
          </label>
        </nav>
      </div>
    </>
  );
};

export default Header;
